import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    contrato: [],
  },
  mutations: {

    getContrato(state, datos) {
      state.contrato = datos;
    },

    
    destroyContrato(state) {
      state.contrato = [];
    },

  },
  actions: {
    async destroyContrato({ commit }) {
      commit('destroyContrato');
    },
    async getContrato({
      commit,
    }) {
      try {
        const res = await api.getContrato();
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getContrato', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async editContrato({ }, cont) {
      try {
        const res = await api.editContrato(cont);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },






  },
};
